var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"summary-item"},[_c('div',{staticClass:"summary-label"},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"summary-value"},[_vm._v(_vm._s(_vm.value || '-'))])])
}
var staticRenderFns = []

export { render, staticRenderFns }